import locale77304fa0 from '../../../../../../locales/de.js'
import locale77427e78 from '../../../../../../locales/en.js'
import locale7744c453 from '../../../../../../locales/es.js'
import locale77526775 from '../../../../../../locales/fr.js'
import localecb0e96ee from '../../../../../../locales/fr-BE.js'
import locale777d96b6 from '../../../../../../locales/it.js'
import locale77c06943 from '../../../../../../locales/nl.js'
import localec7c6900a from '../../../../../../locales/nl-BE.js'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"fallbackLocale":{"en":"en-GB","nl":["nl-NL","nl-BE"],"fr":["fr-FR","fr-BE"],"default":["en","nl"]},"silentFallbackWarn":true},
  vueI18nLoader: true,
  locales: [{"code":"de-DE","iso":"de-DE","file":"de.js","name":"Deutsch","dir":"ltr"},{"code":"en-GB","iso":"en-GB","file":"en.js","name":"English","dir":"ltr"},{"code":"es-ES","iso":"es-ES","file":"es.js","name":"Español","dir":"ltr"},{"code":"fr-FR","iso":"fr-FR","file":"fr.js","name":"Français","dir":"ltr"},{"code":"fr-BE","iso":"fr-BE","file":"fr-BE.js","name":"Français (Belgique)","dir":"ltr"},{"code":"it-IT","iso":"it-IT","file":"it.js","name":"Italiano","dir":"ltr"},{"code":"nl-NL","iso":"nl-NL","file":"nl.js","name":"Nederlands","dir":"ltr"},{"code":"nl-BE","iso":"nl-BE","file":"nl-BE.js","name":"Nederlands (België)","dir":"ltr"}],
  defaultLocale: "nl-BE",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "no_prefix",
  lazy: false,
  langDir: "/builds/bambelo/product-development/chimera/locales",
  rootRedirect: null,
  detectBrowserLanguage: false,
  differentDomains: false,
  seo: true,
  baseUrl: "",
  vuex: {"moduleName":"i18n","syncLocale":false,"syncMessages":false,"syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  beforeLanguageSwitch: () => null,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  normalizedLocales: [{"code":"de-DE","iso":"de-DE","file":"de.js","name":"Deutsch","dir":"ltr"},{"code":"en-GB","iso":"en-GB","file":"en.js","name":"English","dir":"ltr"},{"code":"es-ES","iso":"es-ES","file":"es.js","name":"Español","dir":"ltr"},{"code":"fr-FR","iso":"fr-FR","file":"fr.js","name":"Français","dir":"ltr"},{"code":"fr-BE","iso":"fr-BE","file":"fr-BE.js","name":"Français (Belgique)","dir":"ltr"},{"code":"it-IT","iso":"it-IT","file":"it.js","name":"Italiano","dir":"ltr"},{"code":"nl-NL","iso":"nl-NL","file":"nl.js","name":"Nederlands","dir":"ltr"},{"code":"nl-BE","iso":"nl-BE","file":"nl-BE.js","name":"Nederlands (België)","dir":"ltr"}],
  localeCodes: ["de-DE","en-GB","es-ES","fr-FR","fr-BE","it-IT","nl-NL","nl-BE"],
}

export const localeMessages = {
  'de.js': () => Promise.resolve(locale77304fa0),
  'en.js': () => Promise.resolve(locale77427e78),
  'es.js': () => Promise.resolve(locale7744c453),
  'fr.js': () => Promise.resolve(locale77526775),
  'fr-BE.js': () => Promise.resolve(localecb0e96ee),
  'it.js': () => Promise.resolve(locale777d96b6),
  'nl.js': () => Promise.resolve(locale77c06943),
  'nl-BE.js': () => Promise.resolve(localec7c6900a),
}
